import React, { useEffect, useState } from 'react';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import ProblemSection from './components/sections/ProblemSection';
import GuideSection from './components/sections/GuideSection';
import ChannelsSection from './components/sections/ChannelsSection';
import PlanSection from './components/sections/PlanSection';
import SuccessSection from './components/sections/SuccessSection';
import CTASection from './components/sections/CTASection';
import VideoModal from './components/ui/VideoModal';
export function App() {
  // Video modal state
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const videoUrl = 'https://vimeo.com/1126060291/8fa979bd18?share=copy';
  const openVideoModal = () => setIsVideoModalOpen(true);
  const closeVideoModal = () => setIsVideoModalOpen(false);
  // Add scroll reveal effect
  useEffect(() => {
    const handleScroll = () => {
      const reveals = document.querySelectorAll('.reveal');
      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const revealTop = reveals[i].getBoundingClientRect().top;
        const revealPoint = 150;
        if (revealTop < windowHeight - revealPoint) {
          reveals[i].classList.add('active');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="font-poppins text-gray-800 overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection onWatchDemo={openVideoModal} data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <GuideSection data-id="element-5" />
        <ChannelsSection data-id="element-6" />
        <PlanSection data-id="element-7" />
        <SuccessSection data-id="element-8" />
        <CTASection onWatchDemo={openVideoModal} data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <VideoModal isOpen={isVideoModalOpen} onClose={closeVideoModal} videoUrl={videoUrl} data-id="element-11" />
    </div>;
}